import { render, staticRenderFns } from "./page-notPaiGong-view.vue?vue&type=template&id=ffe2344c&scoped=true&"
import script from "./page-notPaiGong-view.vue?vue&type=script&lang=js&"
export * from "./page-notPaiGong-view.vue?vue&type=script&lang=js&"
import style0 from "./page-notPaiGong-view.vue?vue&type=style&index=0&id=ffe2344c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe2344c",
  null
  
)

component.options.__file = "page-notPaiGong-view.vue"
export default component.exports